import { Group, Select, Stack, Text } from '@mantine/core';
import { useProfile } from 'init/use-enforce-profile';
import { tKeys, tKeysLoose, useTranslation } from 'locales';
import { useLoadLightUsers } from 'shared/hooks/use-load-light-users';

import { useAutomationWizardController } from '../../controller';

import type { ActionCardProps } from './ActionCard';
import { renderFieldItem, selectedFieldStyle } from './components';

export const AssignAccountManager = ({ actionIndex }: ActionCardProps) => {
  const { t } = useTranslation();
  const { form } = useAutomationWizardController();

  const profile = useProfile();
  const shouldLoadUsers = profile.isAdmin || profile.roles.includes('all_invoices');
  const { users = [] } = useLoadLightUsers(false, { query: '' }, { isEnabled: shouldLoadUsers });

  const accountMangers = users.map(user => ({
    label: user.name.full,
    value: String(user.id),
  }));

  return (
    <Stack>
      <Text size="sm" fw={500}>
        {t(
          tKeysLoose.AUTOMATION.ACTIONS_CONFIG[
            `ASSIGN_ACCOUNT_MANAGER_${form.values.targetModel.toUpperCase()}`
          ],
        )}
      </Text>
      <Group gap="xl" align="end">
        <Select
          w={250}
          label={t(tKeys.AUTOMATION.ACTIONS_CONFIG.ACCOUNT_MANAGER_LABEL)}
          placeholder={t(tKeys.AUTOMATION.ACTIONS_CONFIG.ACCOUNT_MANAGER_PLACEHOLDER)}
          renderOption={renderFieldItem}
          allowDeselect={false}
          classNames={{
            option: selectedFieldStyle,
          }}
          data={accountMangers}
          {...form.getInputProps(`actions.${actionIndex}.assignableId`)}
        />
      </Group>
    </Stack>
  );
};
